import {
  useEffect,
  useState,
} from 'react';

import { User } from '../models/User';

import {
  captureSessionTokenFromHash,
  getSessionAuthorizationHeaders,
} from '../services/sessionAuth';

interface SessionUser {
  display_name: string;
}

interface SessionResponse {
  ok: boolean;
  authenticated?: boolean;
  error?: string;
  user?: SessionUser;
}

export const useRetziaUser = () => {
  const [currentUser, setCurrentUser] =
    useState<User | null>(null);

  const [checking, setChecking] =
    useState(true);

  const [sessionError, setSessionError] =
    useState<string | null>(null);

  const [tokenReady] = useState(() => {
    captureSessionTokenFromHash();
    return true;
  });

  useEffect(() => {
    let cancelled = false;

    const loadSession = async () => {
      try {
        const response = await fetch(
          '/api/session.php',
          {
            method: 'GET',
            credentials: 'include',
            cache: 'no-store',
            headers: {
              ...getSessionAuthorizationHeaders(),
              Accept: 'application/json',
            },
          }
        );

        const data =
          (await response.json()) as SessionResponse;

        if (cancelled) {
          return;
        }

        if (
          !response.ok ||
          !data.ok ||
          !data.authenticated ||
          !data.user
        ) {
          setSessionError(
            data.error ??
              'authentication_required'
          );
          setChecking(false);
          return;
        }

        setCurrentUser({
          token: 'server-session',
          name: data.user.display_name,
          isAuthenticated: true,
        });

        setChecking(false);
      } catch (error) {
        if (!cancelled) {
          setSessionError(
            error instanceof Error
              ? error.name
              : 'session_error'
          );
          setChecking(false);
        }
      }
    };

    if (tokenReady) {
      loadSession();
    }

    return () => {
      cancelled = true;
    };
  }, [tokenReady]);

  return {
    currentUser,
    checking,
    sessionError,
  };
};
